<template>
  <el-dialog :title="`${!id ? '新增':'编辑'}活动`" :visible.sync="modalShow">
    <el-form :model="editeForm" ref="editeForm" :rules="rules" size="small" label-width="200px" inline>
      <el-form-item label="活动名称" prop="name">
        <el-input v-model.trim="editeForm.name" placeholder="活动名称" />
      </el-form-item>
      <el-form-item label="状态" prop="state" v-if="!id">
        <el-select v-model.trim="editeForm.state">
          <el-option :value="1" label="启用"></el-option>
          <el-option :value="2" label="停用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="拼团人数" prop="groupNum">
        <el-input v-model.trim="editeForm.groupNum" placeholder="拼团人数" />
      </el-form-item>
      <el-form-item label="拼团时效/小时" prop="validityHour">
        <el-input v-model.trim="editeForm.validityHour" placeholder="拼团时效/小时" />
      </el-form-item>
      <el-form-item label="发起拼团虚拟账户" prop="virtualInitiate">
        <el-select v-model.trim="editeForm.virtualInitiate">
          <el-option :value="1" label="启用"></el-option>
          <el-option :value="2" label="停用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="0元班补位虚拟账户" prop="fillWithZero">
        <el-select v-model.trim="editeForm.fillWithZero">
          <el-option :value="1" label="启用"></el-option>
          <el-option :value="2" label="停用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="补位时间/小时" prop="fillHour">
        <el-input v-model.trim="editeForm.fillHour" maxlength="30" placeholder="补位时间/小时" @input="fillHourchange" />
      </el-form-item>
      <el-form-item label="活动起止时间" prop="startDate">
        <el-date-picker v-model.trim="editeForm.startDate" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" @change="changeTimes" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="胶囊位" prop="capsuleImg">
        <div class="uploadimgs" v-for="(item,index) in editeForm.capsuleImg" :key="index">
          <i class="el-icon-close icon_close" @click="(item,index)=>editeForm.capsuleImg.splice(index,1)"></i>
          <el-image :src="item.fileUrl" class="uploadimgs" />
        </div>
        <imgUpload :list="editeForm.capsuleImg" @childByValue="(value)=>editeForm.capsuleImg.push({...value})" v-if="editeForm.capsuleImg.length == 0" />
      </el-form-item>
      <el-form-item label="活动页图片" prop="activityImg">
        <div class="uploadimgs" v-for="(item,index) in editeForm.activityImg" :key="index">
          <i class="el-icon-close icon_close" @click="(item,index)=>editeForm.activityImg.splice(index,1)"></i>
          <el-image :src="item.fileUrl" class="uploadimgs" />
        </div>
        <imgUpload :list="editeForm.activityImg" @childByValue="(value)=>editeForm.activityImg.push({...value})" v-if="editeForm.activityImg.length == 0" />
      </el-form-item>
      <el-form-item label="温馨提示" prop="alertImg">
        <div class="uploadimgs" v-for="(item,index) in editeForm.alertImg" :key="index">
          <i class="el-icon-close icon_close" @click="(item,index)=>editeForm.alertImg.splice(index,1)"></i>
          <el-image :src="item.fileUrl" class="uploadimgs" />
        </div>
        <imgUpload :list="editeForm.alertImg" @childByValue="(value)=>editeForm.alertImg.push({...value})" v-if="editeForm.alertImg.length == 0" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="modalShow = false">取 消</el-button>
      <el-button type="primary" @click="submit('editeForm')">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import imgUpload from "@/components/upload"
import { Admin } from "../api"
export default {
  components: { imgUpload },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      modalShow: false,
      rules: {
        name: [{ required: true, message: '请输入活动名称！', trigger: 'blur' }],
        groupNum: [
          { required: true, message: '请输入拼团人数！', trigger: 'blur' },
          {
            message: '拼团人数不能高于10人,不能低于2人', validator: (rule, value, callback) => {
              if (value >= 2 && value <= 10) {
                callback()
              } else {
                callback(new Error('拼团人数不能高于10人,不能低于2人'))
              }
            }
          }
        ],
        validityHour: [{ required: true, message: '请输入拼团时效/小时！', trigger: 'change | blur' }],
        fillHour: [
          { required: true, message: '请输入补位时间/小时！', trigger: 'change | blur' },
          {
            message: '格式不正确，需精确到小数点后一位', validator: (rule, value, callback) => {
              const val = value.toString()
              if (!value) {
                callback(new Error('请输入拼团补位时间/小时'))
              } else if (val.indexOf('.') !== -1 && val.split('.')[1].length > 1 || val.indexOf('.') !== -1 && !val.split('.')[1] ) {
                callback(new Error('格式不正确，需精确到小数点后一位'))
              } else if (val.indexOf('.') !== -1 && val.split('.')[1].length > 1) {
                callback(new Error('格式不正确，需精确到小数点后一位'))
              } else {
                callback()
              }
            }
          }
        ],
        virtualInitiate: [{ required: true, message: '请选择虚拟用户发起拼团！', trigger: 'change | blur' }],
        fillWithZero: [{ required: true, message: '请选择0元班补位虚拟账户！', trigger: 'change | blur' }],
        startDate: [{ required: true, message: '请选择活动开始时间！', trigger: 'blur' }],
        state: [{ required: true, message: '请选择活动状态！', trigger: 'change' }],
        capsuleImg: [{ required: true, message: '请上传胶囊位图片！', trigger: 'blur' }],
        activityImg: [{ required: true, message: '请上传活动图片！', trigger: 'blur' }],
        alertImg: [{ required: true, message: '请上传温馨提示图片！', trigger: 'blur' }]
      },
      editeForm: {
        name: "",
        groupNum: "",
        validityHour: "",
        fillHour: "",
        virtualInitiate: "",
        fillWithZero: "",
        startDate: null,
        endDate: null,
        state: null,
        capsuleImg: [],
        activityImg: [],
        alertImg: []
      },
      times: [],
      id: null
    }
  },
  methods: {
    init (row) {
      this.modalShow = true
      setTimeout(() => {
        this.$refs['editeForm'].resetFields()
        if (row && row.id) {
          this.id = row.id
          this.getDetail()
        } else {
          this.id = null
        }
      }, 50);
    },
    fillHourchange (value) {
      this.editeForm.fillHour = value.replace(/[^0-9.]/g, '')
    },
    changeTimes (e) {
      console.log(e)
      this.editeForm.startDate = e
      // this.editeForm.startDate = e[0]
      // this.editeForm.endDate = e[1]
    },
    submit (formName) {
      const params = Object.assign({}, { ...this.editeForm })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const times = [...params.startDate]
          for (const key in params) {
            if (key == 'capsuleImg' || key == 'activityImg' || key == "alertImg") {
              params[key] = params[key].map(item => item.fileUrl).join(',')
            }
          }
          params.startDate = times[0]
          params.endDate = times[1]
          if (!this.id) {
            this.addData(params)
          } else {
            params.id = this.id
            this.updateData(params)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getDetail () {
      const res = await Admin.getActivitySpellGroup({ id: this.id })
      if (res.code !== 0) return;
      const { data } = res || {}
      for (const key in this.editeForm) {
        if (data[key] ?? false) {
          if (key == 'capsuleImg' || key == 'activityImg' || key == "alertImg") {
            this.editeForm[key] = [{ fileUrl: data[key] }]
          } else {
            this.editeForm[key] = data[key]
          }
        }
      }
      this.editeForm.startDate = [data.startDate, data.endDate]
    },
    async addData (params) {
      const res = await Admin.addActivitySpellGroup(params)
      if (res.code !== 0) return
      this.$message.success('操作成功！')
      this.$bus.$emit('update', true)
      this.modalShow = false
    },
    async updateData (params) {
      const res = await Admin.updateActivitySpellGroup(params)
      if (res.code !== 0) return
      this.$message.success('操作成功！')
      this.$bus.$emit('update', true)
      this.modalShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.act_img {
  width: 120px;
  height: 120px;
  background-color: #f4f4f4f4;
  border: none;
}
.uploadimgs {
  width: 120px;
  position: relative;
  .icon_close {
    position: absolute;
    right: -8px;
    top: -8px;
    font-size: 18px;
    z-index: 2;
    padding: 2px;
    color: #ffffff;
    background: rgba($color: #000000, $alpha: 0.6);
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>